import { styled } from '@ori-ui/mui';

import { maxWidth } from '../../constants';

export const Root = styled('div')(() => ({
  display: 'flex',
  maxWidth,
  flexDirection: 'column',
  textAlign: 'center',
  alignItems: 'center',
}));
